import React from "react";

function UserMessage({ message }) {
	return (
		<div className="userMessage">
			<span>{message}</span>
		</div>
	);
}

export default UserMessage;
